import { useEffect, useState } from "react";
import { Navigate, Route } from "react-router-dom";

const AuthProtected = (props) => {
  const [isAuth, setIsAuth] = useState(true);

  useEffect(() => {
    if (localStorage.getItem("token")) {
      setIsAuth(true);
    } else {
      setIsAuth(false);
    }
  }, []);

  if (!isAuth) {
    return <Navigate to={{ pathname: "/login" }} />;
  }

  return props.children;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return <Component {...props} />;
      }}
    />
  );
};

export { AuthProtected, AccessRoute };
